<template>
  <v-chip :color="ticketStatusColors[status]" prepend-icon="label" label>
    <div class="text-high-emphasis text-body-medium">
      {{ $te(`tickets.status.status.${status}.name`) ? $t(`tickets.status.status.${status}.name`) : status }}
    </div>
  </v-chip>
</template>

<script setup lang="ts">
const { status } = defineProps<{ status: TicketStatus }>()
</script>
